export default {
  name: "v-ifas-card",
  props: {
    header: String,
    cardDescription: String,
    cardBodyClass: String,
    cardHeaderClass: String,
    noHeader: Boolean,
    cardId: String,
    nonCollapsible: Boolean,
    collapsed: Boolean,
    toggleCollapse: Function,
    cardSummaryItems: Array,
    nextCardId: String,
    noIcon: Boolean,
    visible: Boolean,
    isProcessStep: Boolean,
    tooltip: String,
    typeOfHeader: String
  },
  computed: {
    hasHeaderSlot: function hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasFooterSlot: function hasFooterSlot() {
      return !!this.$slots.footer;
    },
    hasButtons: function hasButtons() {
      return !!this.$slots.buttons;
    },
    hasCardDescription: function hasCardDescription() {
      return !!this.$slots.cardDescription;
    },
    stringifySummaryItems: function stringifySummaryItems() {
      if (!this.cardSummaryItems) return "";
      if (this.cardSummaryItems && this.cardSummaryItems.length === 0) return "";else {
        var _this$cardSummaryItem;
        var concatenatedString = (_this$cardSummaryItem = this.cardSummaryItems) === null || _this$cardSummaryItem === void 0 ? void 0 : _this$cardSummaryItem.reduce(function (a, c) {
          return a + " | " + c;
        }, "");
        return concatenatedString.replace("|", "");
      }
    }
  }
};